import type { Doc } from "building-types/doc";
import type { OptionSetHandle, PresetHandle } from "building-types/handles/docEntityHandleTypes";
import type { Preset } from "building-types/options/preset";
import type { Table, RWTable } from "common/data/table";

export function docGetPreset(doc: Doc, handle: PresetHandle): Preset | undefined {
  return doc.presets[handle?.id];
}

export function docGetOptionSetPresets(doc: Doc, handle: OptionSetHandle): Table<Preset> {
  const presets: RWTable<Preset> = {};

  for (const id in doc.presets) {
    const preset = doc.presets[id];

    if (preset.optionChoices[handle.id]) {
      presets[id] = preset;
    }
  }

  return presets;
}
